import { modifyUserProfileImgApi } from '@/api/userApis';
import {showAlert} from '@/script/common/popupScript';
import {IMG_EXT_LIST, IMG_SIZE_LIMIT} from '@/config/constants';

export const getProfileSrc = (src: string) => {
  return src ? src : require('@/assets/images/pictures/profile_default.png')
}

export const useProfileImageEdit = () => {

  const inputImage = async (image: File | any) => {
    try {
      if (image instanceof File) {
        const parts = image.name.split('.');
        const ext = parts.pop();
        if (image.size > IMG_SIZE_LIMIT || (ext && !IMG_EXT_LIST.includes(ext))) {
          throw 'upload error'
        }
      }
      const formData = new FormData()
      formData.set('image', image)
      await modifyUserProfileImgApi(formData)
    } catch(e) {
      showAlert('업로드에 실패했습니다.\n아래 이미지규격을 확인해 주세요.\n크기: 5MB 이하\n확장자: jpg, jpeg, png, webp')
    }

  }

  return {
    inputImage,
  }
}
